export const CHANGE_COURIER = Symbol('CHANGE_COURIER')
export const CHANGE_COURIER_REQUEST = Symbol('CHANGE_COURIER_REQUEST')
export const CHANGE_COURIER_SUCCESS = Symbol('CHANGE_COURIER_SUCCESS')
export const CHANGE_COURIER_ERROR = Symbol('CHANGE_COURIER_ERROR')

export const GET_FILTERED_COURIERS_LIST = Symbol('GET_FILTERED_COURIERS_LIST')
export const GET_FILTERED_COURIERS_LIST_REQUEST = Symbol('GET_FILTERED_COURIERS_LIST_REQUEST')
export const GET_FILTERED_COURIERS_LIST_SUCCESS = Symbol('GET_FILTERED_COURIERS_LIST_SUCCESS')
export const GET_FILTERED_COURIERS_LIST_ERROR = Symbol('GET_FILTERED_COURIERS_LIST_ERROR')
